import { render, staticRenderFns } from "./KCSwitch.vue?vue&type=template&id=14c2ea9d&scoped=true&"
import script from "./KCSwitch.vue?vue&type=script&lang=js&"
export * from "./KCSwitch.vue?vue&type=script&lang=js&"
import style0 from "./KCSwitch.vue?vue&type=style&index=0&id=14c2ea9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c2ea9d",
  null
  
)

export default component.exports